import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import '../../style/accessibleView.scss';
import InfoModal from '../Modal/InfoModal';

class Header extends Component {
  state = {
    infoModal: false,
    switchView: false,
    modalText: ""
  };


  openInformationModal = () => {
    this.setState({
      infoModal: true,
    });
  };

  closeInformationModal = () => {
    this.setState({
      infoModal: false,
    });
  };


  changeViewMode = () => {
    this.setState({ switchView: !this.state.switchView }, () => {
      sessionStorage.setItem("accessibleView", this.state.switchView)
      this.props.changeView(this.state.switchView)
    })
  }

  render() {
    const { infoModal } = this.state;
    const { title } = this.props;
    const { huntekaConfig } = this.props

    return (
      <header>
        <Container>
          <span>{title}</span>
          <span className="float-right">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className={"m-1"}
            onClick={this.openInformationModal}
          />
          <FontAwesomeIcon
            className={"m-1"}
            icon={faEye}
            onClick={this.changeViewMode}
          />
          </span>
        </Container>
        {infoModal ? (
          <InfoModal
            classNames={sessionStorage.getItem("accessibleView") === "true" ? "accessibleModal" : ""}
            title={<FormattedMessage id="infomodal.title" />}
            show={infoModal}
            close={this.closeInformationModal}
          >

            {huntekaConfig !== undefined ?
              <div className="pre-line-style" dangerouslySetInnerHTML={{ __html: huntekaConfig.informationText }} />
              : <div>
                <div className="pre-line-style"><FormattedMessage id="infomodal.body.base.msg" />
                </div>
                <h5>
                  <FormattedMessage id="infomodal.body.privacypolicy.title" />
                </h5>
                <div className="pre-line-style">
                  <FormattedMessage id="infomodal.body.privacypolicy.msg" />
                </div>
              </div>
            }
          </InfoModal>
        ) : null}
      </header>
    );
  }
}

export default Header;
